var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.disList),function(item){return _c('li',{class:_vm.setBg(item)},[_vm._v(_vm._s(item))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }